import Subheadline from "../Elements/Subheadline";
import ProfileCard from "../Cards/CardProfile";
import BtnSecondaryM from "../Buttons/BtnSecondaryM";
import PropTypes from "prop-types";

const TabDataPrivacy = ({ copy }) => (
  <>
    <Subheadline
      subheadline={copy.profile.tab_6}
      description={copy.profile.tab_6_description}
    />
    <div className="flex flex-col gap-3">
      <ProfileCard
        title="Privacy Policy"
        description="Learn how Niumi collects, uses, and protects your personal data when you use our platform. Your privacy matters to us."
      >
        <BtnSecondaryM
          buttonCTA={copy.profile.data_privacy.legal_terms.privacy_policy}
          onClickLink="https://www.niumi.dk/legal/privacy-policy/"
        />
      </ProfileCard>

      <ProfileCard
        title="Terms of Service"
        description="Review the rules and conditions that govern your use of Niumi. By using our service, you agree to these terms."
      >
        <BtnSecondaryM
          buttonCTA={copy.profile.data_privacy.legal_terms.terms_of_service}
          onClickLink="https://www.niumi.dk/legal/terms-of-service/"
        />
      </ProfileCard>

      <ProfileCard
        title="Cookie Policy"
        description="Explains how Niumi uses cookies for functionality, preferences, and analytics."
      >
        <BtnSecondaryM
          buttonCTA={copy.profile.data_privacy.legal_terms.cookie_policy}
          onClickLink="https://www.niumi.dk/legal/cookie-policy/"
        />
      </ProfileCard>
    </div>
  </>
);

TabDataPrivacy.propTypes = {
  copy: PropTypes.object.isRequired,
};

export default TabDataPrivacy;
